import { render, staticRenderFns } from "./RegistSuccess.vue?vue&type=template&id=63f58847&scoped=true&"
import script from "./RegistSuccess.vue?vue&type=script&lang=js&"
export * from "./RegistSuccess.vue?vue&type=script&lang=js&"
import style0 from "./RegistSuccess.vue?vue&type=style&index=0&id=63f58847&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f58847",
  null
  
)

export default component.exports